<template>
  <vetalfa-dialog
    v-on:dialogClose="model = false"
    :toggleModel="model"
    fullscreen
    :featureMode="false"
    :smallHeader="false"
    persistent
    backgroundColor="white"
    :height="_xsOnly() ? _getWindowHeight() : _getWindowHeight() * 0.7"
  >
    <template v-slot:header>
      <v-row
        no-gutters
        align="center"
        justify="space-between"
        class="px-2 vetalfa-padding-top-notch mt-4"
      >
        <v-col>
          <v-row no-gutters align="start" class="vetalfa-row">
            <v-icon size="22" color="primary" class="mx-1 pt-1">{{
              _icon("flashcardsIcon")
            }}</v-icon>
            <span
              class="ma-0 pa-0 ml-1 primary--text subtitle-1 font-weight-bold"
            >
              Flashcards
            </span>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-row no-gutters class="vetalfa-row" align="start">
            <v-btn icon @click="closeClick">
              <v-icon size="20" color="primary">{{ mdiClose }}</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-if="!checkpoint"
        no-gutters
        justify="space-between"
        class="pl-1 vetalfa-padding-top-notch mt-4"
      >
        <v-col cols="1" v-if="step > 0">
          <v-row no-gutters class="vetalfa-row" align="center" justify="start">
            <v-icon icon @click="stepBackClick" size="20" color="primary">{{
              mdiChevronLeft
            }}</v-icon>
          </v-row>
        </v-col>
        <v-col :cols="step > 0 ? 9 : 10" class="ma-0 pa-0">
          <v-row
            no-gutters
            @click="showCheckpointClick"
            align="center"
            class="vetalfa-row"
            :class="[step == 0 ? 'pl-3' : '']"
          >
            <v-progress-linear
              v-model="progressValue"
              rounded
              background-color="rgba(242, 242, 242, 1)"
              color="rgba(20, 146, 20, 1)"
              class="vetalfa-pointer"
              height="6"
            ></v-progress-linear>
          </v-row>
        </v-col>
        <v-col cols="2" class="ma-0 pa-0">
          <v-row
            no-gutters
            @click="showCheckpointClick"
            align="center"
            justify="end"
            class="vetalfa-row pr-3"
          >
            <span class="vetalfa-pointer pa-0 ma-0 subtitle-1 primary--text">
              {{ progressText }}
            </span>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <v-row
      v-if="!!checkpoint"
      no-gutters
      justify="center"
      align-content="space-between"
      class="px-3"
    >
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <p class="ma-0 pa-0 mt-4 primary--text text-h6 font-weight-bold mb-2">
            Seu Progresso
          </p>
        </v-row>
        <v-row no-gutters justify="center">
          <v-progress-circular
            :rotate="0"
            :size="80"
            :width="8"
            :value="progressValue"
            color="rgba(20, 146, 20, 1)"
            background-color="white"
          >
            <span class="pa-0 ma-0 font-weight-bold text-h6 primary--text">
              {{ progressText }}
            </span>
          </v-progress-circular>
        </v-row>
        <v-row no-gutters justify="center">
          <v-card
            class="ma-0 pa-0 mt-6 pt-2 pb-1"
            elevation="0"
            color="#F2F2F2"
            style="width: 70%; border-radius: 20px"
          >
            <v-row no-gutters justify="center">
              <p
                class="ma-0 pa-0 primary--text subtitle-1 font-weight-bold mb-1"
                style="line-height: 16px"
              >
                Escore
              </p>
            </v-row>
            <v-row no-gutters justify="center">
              <p
                class="pa-0 ma-0 font-weight-bold subtitle-1 primary--text"
                style="line-height: 16px"
              >
                {{ _formatNumber(averageScore) }}
              </p>
            </v-row>
            <v-row no-gutters justify="center">
              <v-rating
                :empty-icon="mdiStarOutline"
                :full-icon="mdiStar"
                :half-icon="mdiStarHalfFull"
                dense
                half-increments
                hover
                length="5"
                size="18"
                background-color="rgba(255, 199, 1, 1)"
                color="rgba(255, 199, 1, 1)"
                :value="averageScore"
                readonly
              >
              </v-rating>
            </v-row>
          </v-card>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-10">
        <v-list dense class="white pa-0 ma-0">
          <v-list-item @click="showHowItWorks">
            <v-list-item-content>
              <v-list-item-title
                class="primary--text subtitle-1 font-weight-bold"
                style="line-height: 24px"
                >{{ _getLabel("HOW_IT_WORKS_QUESTION") }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action class="primary--text">
              <v-icon size="16" color="primary" class="mx-1 pt-1">{{
                mdiHelpCircle
              }}</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider class="primary mx-4" style="opacity: 0.1"></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                style="line-height: 24px"
                class="primary--text subtitle-1 font-weight-bold"
                >{{ _getLabel("CATEGORY") }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action class="black--text subtitle-2">
              {{ categoryNameData }}
            </v-list-item-action>
          </v-list-item>
          <v-divider class="primary mx-4" style="opacity: 0.1"></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                style="line-height: 24px"
                class="primary--text subtitle-1 font-weight-bold"
                >Assunto</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action
              class="black--text subtitle-2 vetalfa-text-overflow"
              >{{ subjectName }}</v-list-item-action
            >
          </v-list-item>
          <v-divider class="primary mx-4" style="opacity: 0.1"></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                style="line-height: 24px"
                class="primary--text subtitle-1 font-weight-bold"
                >{{
                  _getLabel("FLASH_CARDS_AVERAGE_UNIQUE_CARDS_ANSWERED")
                }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action justify="end" class="black--text subtitle-2">
              {{ questionsTotalText }}
            </v-list-item-action>
          </v-list-item>
          <v-divider class="primary mx-4" style="opacity: 0.1"></v-divider>
        </v-list>
      </v-col>
    </v-row>
    <v-row
      id="vetalfa-flash-cards-container"
      v-else
      no-gutters
      justify="center"
      align="center"
      class="py-4 px-5 vetalfa-row"
      style="overflow: hidden"
      @click="seeResultsClick"
    >
      <v-card class="white flip-card vetalfa-pointer" flat :height="cardHeight">
        <v-row
          no-gutters
          class="flip-card-inner"
          id="flip-card-inner"
          :class="{
            'flip-card-inner-rotate': seeResults,
          }"
        >
          <v-col class="ma-0 pa-5 flip-card-front white--text" cols="12">
            <v-row no-gutters>
              <v-col cols="12" class="ma-0 pa-0">
                <v-row no-gutters>
                  <p
                    class="ma-0 pa-0 font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                  >
                    <span class="font-weight-bold">
                      {{ `${_getLabel("CATEGORY")}:` }}
                    </span>
                    {{ categoryNameData }}
                  </p>
                </v-row>
                <v-row no-gutters>
                  <p
                    class="ma-0 pa-0 font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                  >
                    <span class="font-weight-bold">Assunto: </span>
                    {{ cards[step].content_name }}
                  </p>
                </v-row>
                <v-divider class="mt-2 white"></v-divider>
                <v-row no-gutters align="start" justify="start">
                  <p
                    class="white--text mt-2 ma-0 pa-0 text-center font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                    style="opacity: 0.3"
                  >
                    Pergunta:
                  </p>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              align="center"
              justify="center"
              class="vetalfa-row pr-4"
              style="
                position: absolute;
                top: 0px;
                display: flex;
                flex-direction: column;
                padding-top: 60px;
              "
            >
              <p
                class="ma-0 pa-0 text-left white--text"
                :class="[
                  cardHeight > 450
                    ? 'text-h5'
                    : cardHeight > 400
                    ? 'text-h6'
                    : 'subtitle-1',
                ]"
                style="width: 100%; margin-top: auto"
                v-html="
                  highlightNameInQuestion(
                    cards[step].question,
                    cards[step].content_name
                  )
                "
              ></p>
            </v-row>
          </v-col>
          <v-col cols="12" class="flip-card-back ma-0 pa-5 white--text">
            <v-row no-gutters>
              <v-col cols="12" class="ma-0 pa-0">
                <v-row no-gutters>
                  <p
                    class="ma-0 pa-0 font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                  >
                    <span class="font-weight-bold">{{
                      `${_getLabel("CATEGORY")}:`
                    }}</span>
                    {{ categoryNameData }}
                  </p>
                </v-row>
                <v-row no-gutters>
                  <p
                    class="ma-0 pa-0 font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                  >
                    <span class="font-weight-bold">Assunto: </span>
                    {{ cards[step].content_name }}
                  </p>
                </v-row>
                <v-divider class="mt-2 white"></v-divider>
                <v-row no-gutters align="start" justify="start">
                  <p
                    class="white--text mt-2 ma-0 pa-0 text-center font-weight-normal text-left"
                    :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
                    style="opacity: 0.3"
                  >
                    Resposta:
                  </p>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              align="center"
              justify="center"
              class="vetalfa-row pr-4"
              style="
                position: absolute;
                top: 0px;
                display: flex;
                flex-direction: column;
                padding-top: 60px;
              "
            >
              <p
                class="ma-0 pa-0 text-left white--text"
                :class="[
                  cardHeight > 450
                    ? 'text-h5'
                    : cardHeight > 400
                    ? 'text-h6'
                    : 'subtitle-1',
                ]"
                style="width: 100%; margin-top: auto"
                v-html="cards[step].answer"
              ></p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-row>

    <template v-slot:actions>
      <v-col
        cols="12"
        class="ma-0 pa-0"
        :style="{ height: !!checkpoint ? '90px' : '150px' }"
      >
        <v-row
          v-if="!!checkpoint"
          no-gutters
          align="start"
          justify="center"
          class="px-6"
        >
          <v-btn
            @click="startClick()"
            rounded
            large
            :loading="loading"
            width="240"
            class="subtitle-1 primary white--text text-none font-weight-bold"
          >
            {{ _getLabel(!step ? "START" : "CONTINUE") }}
          </v-btn>
        </v-row>
        <v-row
          v-else-if="!transitionInProgress && !seeResults"
          no-gutters
          justify="center"
          class="px-6 pb-8 primary--text"
          :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
        >
          <span style="opacity: 0.5"
            >Clique sobre o card para ver a resposta.</span
          >
        </v-row>
        <v-row
          v-else-if="!transitionInProgress"
          no-gutters
          justify="center"
          class="px-4 pb-8"
        >
          <v-col class="ma-0 pa-0" cols="12">
            <v-row justify="center" no-gutters>
              <p
                class="ma-0 pa-0 text-center primary--text"
                :class="[cardHeight > 400 ? 'subtitle-1' : 'subtitle-2']"
              >
                Qual era o seu nível de conhecimento?
              </p>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 px-6" cols="12">
            <v-row justify="space-between" class="mt-3" no-gutters>
              <v-btn
                fab
                @click="scoreClick(scoreIndex)"
                v-for="scoreIndex in 5"
                :key="`scoreIndex${scoreIndex}`"
                :color="scoreColors[scoreIndex - 1]"
                class="white--text"
                small
                height="48px"
                width="48px"
              >
                <span class="subtitle-1">{{ scoreIndex }}</span>
              </v-btn>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 px-8" cols="12">
            <v-row
              justify="space-between"
              class="mt-2 ma-0 pa-0 text-center primary--text caption"
            >
              <span>Precisa melhorar</span><span>Ótimo</span>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="
            !checkpoint &&
            !!cards[step] &&
            !!cards[step].score &&
            !transitionInProgress &&
            !seeResults
          "
          no-gutters
          justify="center"
          class="mt-2"
        >
          <v-chip outlined dense color="primary">
            <span class="primary--text text-center ma-0 pa-0 caption">
              {{
                `Este item já foi respondido com o escore: ${cards[step].score}`
              }}
            </span>
          </v-chip>
        </v-row>
      </v-col>
    </template>
  </vetalfa-dialog>
</template>

<style scoped>
.flip-card {
  width: 100%;
}

.flip-card-inner::before {
  content: "";
  height: 100px;
  width: 100%;
}
/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.4s;
  transform-style: preserve-3d;
}
/* Define a keyframes animation for the fade out effect */
@keyframes flipCardsFadeOut {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}
@keyframes flipCardsFadeIn {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.flip-card-inner.fade-out {
  animation: flipCardsFadeOut 0.4s forwards;
}
.flip-card-inner.fade-in {
  animation: flipCardsFadeIn 0.4s forwards;
}
.flip-card-inner-rotate {
  transform: rotateY(180deg);
}
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.flip-card-front {
  background-color: #193153;
  border-radius: 20px;
}
.flip-card-back {
  background-color: #193153;
  transform: rotateY(180deg);
  border-radius: 20px;
}
</style>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import systems from "@/constants/systems.enums.js";
import {
  mdiClose,
  mdiStarOutline,
  mdiStarHalfFull,
  mdiStar,
  mdiChevronLeft,
  mdiDotsVertical,
  mdiHelpCircle,
  mdiDotsHorizontal,
} from "@mdi/js";
export default {
  name: "Flashcards",
  props: {
    contentType: {
      type: Object,
      default: null,
      required: false,
    },
    subject: {
      type: String,
      default: "",
      required: false,
    },
    categoryName: {
      type: String,
      default: "",
      required: false,
    },
  },
  computed: {
    ...mapGetters("preferences", [
      "getCards",
      "cardsProgress",
      "answersDailyLimit",
      "searchList",
    ]),
    ...mapGetters("drugs", ["drug", "category"]),
    ...mapGetters("general", ["isPremium", "loading"]),
    ...mapGetters("topics", ["item", "topic"]),
    targetItem() {
      return this.$route.name === "drugs" ? this.drug : this.item;
    },
    questionsTotal() {
      return this.contentType && this.classProgress
        ? this.classProgress.total
        : this.cards.length;
    },
    questionsTotalText() {
      return `${this.answered} de ${this.questionsTotal}`;
    },
    subjectName() {
      let name =
        this.subject ||
        (this.contentType
          ? this.contentType.card_class
          : this.targetItem
          ? this.targetItem.name
          : this.subject);
      if (name.length < 30 || (name.length < 100 && !this._isMobile())) {
        return name;
      }
      return name.substring(0, 30) + "...";
    },
    cards: {
      get() {
        return this.getCards;
      },
      set(val) {
        this.setCards(val);
      },
    },
    classSystem() {
      let obj = {};
      for (let item of systems) {
        for (let subItem of item.classes) {
          obj[subItem] = item.system;
        }
      }
      return obj;
    },
  },
  methods: {
    ...mapMutations("general", ["setConfirmModel"]),
    ...mapMutations("preferences", ["setCards"]),
    ...mapActions("preferences", ["postCardAnswers", "getCardsByProps"]),
    ...mapActions("purchases", ["openPurchases"]),
    ...mapActions("general", ["logEvent", "displayHelpArticle"]),
    setClassProgress() {
      if (this.contentType) {
        this.classProgress = {
          card_class: this.contentType.card_class,
          content_type: this.contentType.content_type,
          total: 0,
          answers_total: 0,
          average_latest_score: 0,
        };
        this.cardsProgress.forEach((p) => {
          let tempClasses = this.searchList.find(
            (i) => i.id == p.content_id
          ).classes;
          if (this.contentType.content_type == 1) {
            tempClasses = tempClasses
              .map((c) => this.classSystem[c.trim()])
              .filter((c) => {
                return !!c;
              });
          }
          if (tempClasses.includes(this.contentType.card_class)) {
            this.classProgress.total += p.total;
            if (this.classProgress.answers_total + p.answers_total > 0) {
              this.classProgress.average_latest_score =
                (p.average_latest_score * p.answers_total +
                  this.classProgress.answers_total *
                    this.classProgress.average_latest_score) /
                (this.classProgress.answers_total + p.answers_total);
            }
            this.classProgress.answers_total += p.answers_total;
          }
        });
        this.classProgress["progress"] = Math.round(
          (this.classProgress.answers_total / this.classProgress.total) * 100,
          0
        );
        this.classProgress["average_latest_score"] = this._roundNumber(
          this.classProgress.average_latest_score,
          1
        );
      }
      this.computeAllProps();
    },
    computeAnswered() {
      let { cards, contentType, classProgress } = this;
      this.answered =
        contentType && classProgress
          ? classProgress.answers_total
          : cards.filter((item) => typeof item.score === "number").length;
    },
    computeAverageScore() {
      let { cards, _roundNumber, answered, contentType, classProgress } = this;
      if (contentType && classProgress) {
        this.averageScore = classProgress.average_latest_score;
        return;
      }
      let sum = 0;
      cards.forEach((item) => {
        let score = item.score;
        if (typeof score === "number") {
          sum += score;
        }
      });
      this.averageScore = _roundNumber(sum / (answered || 1), 1);
    },
    computeProgressValue() {
      let { cards, _roundNumber, answered, contentType, classProgress } = this;
      if (contentType && classProgress) {
        this.progressValue =
          !classProgress.progress && classProgress.answers_total
            ? 1
            : classProgress.progress;
        return;
      }
      this.progressValue = _roundNumber((answered * 100) / cards.length, 0);
    },
    computeProgressText() {
      let {
        cards,
        _roundNumber,
        answered,
        contentType,
        _formatNumber,
        classProgress,
      } = this;
      if (contentType && classProgress) {
        let minorThanSymbol =
          !classProgress.progress && classProgress.answers_total ? "<" : "";
        this.progressText =
          minorThanSymbol +
          _formatNumber(minorThanSymbol ? 1 : classProgress.progress, "%");
        return;
      }
      this.progressText = _formatNumber(
        _roundNumber((answered * 100) / cards.length, 0),
        "%"
      );
    },
    computeAllProps() {
      this.computeAnswered();
      this.computeAverageScore();
      this.computeProgressText();
      this.computeProgressValue();
    },
    closeClick() {
      this.setConfirmModel({
        text: this._getMessage("FLASH_CARDS_EXIT_CONFIRMATION"),
        callback: () => {
          this.model = false;
        },
        confirmText: this._getLabel("CLOSE"),
        closeText: this._getLabel("FLASH_CARDS_KEEP_OPEN"),
      });
    },
    async stepBackClick() {
      this.step--;
      await this.$nextTick();
      this.seeResults = false;
    },
    getCardHeight() {
      const el = document.getElementById("vetalfa-flash-cards-container");
      window.removeEventListener("resize", this.getCardHeight);
      if (el) {
        window.addEventListener("resize", this.getCardHeight);
        this.cardHeight = el.offsetHeight - 50;
      }
    },
    async scoreClick(scoreIndex) {
      document.getElementById("flip-card-inner").classList.remove("fade-in");
      document.getElementById("flip-card-inner").classList.add("fade-out");
      const previousAnswer = {
        hasPreviousAnswer: typeof this.cards[this.step]["score"] === "number",
        previousScore: this.cards[this.step]["score"],
      };
      const allAnswered =
        this.answered + 1 == this.questionsTotal &&
        typeof this.cards[this.step]["score"] !== "number";
      this.cards[this.step]["score"] = scoreIndex;
      this.postCardAnswers({
        card: this.cards[this.step],
        previousAnswer,
      });
      this.computeAllProps();
      if (allAnswered || this.step + 1 == this.cards.length) {
        this.step = this.step + 1 == this.cards.length ? 0 : this.step + 1;
        this.showCheckpointClick();
        return;
      }
      this.transitionInProgress = true;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 200));
      this.seeResults = false;
      this.step++;
      document.getElementById("flip-card-inner").classList.remove("fade-out");
      await this.$nextTick();
      document.getElementById("flip-card-inner").classList.add("fade-in");
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 200));
      document.getElementById("flip-card-inner").classList.remove("fade-in");
      this.transitionInProgress = false;
    },
    async showCheckpointClick() {
      this.checkpoint = true;
    },
    highlightNameInQuestion(question, name) {
      let re = new RegExp("\\b" + name + "\\b", "gi");
      return question.replace(re, function (match) {
        return "<b>" + match.charAt(0).toUpperCase() + match.slice(1) + "</b>";
      });
    },
    displayPaywall() {
      this.setConfirmModel({
        text: this._getMessage("FLASH_CARDS_FREE_LIMIT"),
        callback: () => {
          this.openPurchases();
        },
        confirmText: this._getLabel("CONTINUE"),
        alert: true,
      });
    },
    showHowItWorks() {
      this.logEvent("flashcards_how_it_works");
      this.displayHelpArticle({ id: process.env.VUE_APP_FAQ_FLASH_CARDS });
    },
    seeResultsClick() {
      if (this.answersDailyLimit && !this.isPremium && !this.seeResults) {
        return this.displayPaywall();
      }
      this.seeResults = !this.seeResults;
      this.getCardHeight();
    },
    async startClick(forceStart = false) {
      if (this.answersDailyLimit && !this.isPremium) {
        return this.displayPaywall();
      }
      if (!forceStart && this.answered == this.questionsTotal) {
        this.setConfirmModel({
          text: this._getMessage("FLASH_CARDS_ANSWER_AGAIN_ALERT"),
          callback: () => {
            this.startClick(true);
          },
          confirmText: this._getLabel("CONTINUE"),
          closeText: this._getLabel("CLOSE"),
        });
        return;
      }
      if (this.contentType && !this.firstStart) {
        await this.getCardsByProps(this.contentType);
      }
      this.firstStart = false;
      this.checkpoint = false;
      this.step = this.step || 0;
      this.seeResults = false;
      this.$nextTick(() => {
        this.getCardHeight();
      });
    },
  },
  data() {
    return {
      firstStart: true,
      answered: 0,
      averageScore: 0,
      progressValue: 0,
      progressText: "0%",
      model: false,
      mdiClose,
      mdiStarOutline,
      mdiStarHalfFull,
      mdiChevronLeft,
      mdiStar,
      mdiDotsVertical,
      mdiHelpCircle,
      mdiDotsHorizontal,
      checkpoint: true,
      step: 0,
      seeResults: false,
      cardHeight: 0,
      transitionInProgress: false,
      scoreColors: [
        "rgba(246, 0, 0, 1)",
        "rgba(236, 161, 17, 1)",
        "rgba(252, 139, 35, 1)",
        "rgba(77, 202, 77, 1)",
        "rgba(20, 146, 20, 1)",
      ],
      classProgress: null,
      categoryNameData: null,
    };
  },
  watch: {
    async cards(val) {
      this.model = !!val && !!val.length;
      this.computeAllProps();
      if (this.model) {
        await this.$nextTick();
        this.getCardHeight();
        this.step = 0;
        this.seeResults = false;
        this.checkpoint = true;
        this.transitionInProgress = false;
      }
    },
    cardsProgress() {
      this.setClassProgress();
    },
    async checkpoint(val) {
      this.computeAllProps();
    },
    contentType() {
      this.setClassProgress();
    },
    model(val) {
      if (!val) {
        this.checkpoint = false;
      }
    },
  },
  async mounted() {
    this.model = false;
    await this.$nextTick();
    this.getCardHeight();
    this.setClassProgress();
    if (!this.categoryName) {
      this.categoryNameData =
        this.$route.name === "drugs"
          ? this.category.portugueseName
          : this._getLabel("DISEASES_TITLE");
    } else {
      this.categoryNameData = this.categoryName;
    }
  },
};
</script>